import { DropdownMenu } from '../../../assets/scripts/components/dropdown-menu'
import Component from '../../../assets/scripts/modules/component'
import { clickedOutsideSingle } from '../../../assets/scripts/utilities/outside-click'

export default class LanguageSwitchComponent extends Component {
  init () {
    this.html = document.querySelector('html')
    this.containerContent = document.querySelector('.container--content')
    this.languageSwitchMenu = this.element.querySelector('.language-switch__menu')
    this.menuBar = document.querySelector('.menu-bar .menu-bar__grid')
    this.selectedLanguage = this.element.querySelector('.language-switch__selected')
    this.googleTranslateElement = document.querySelector('#google_translate_element')
    this.googleTranslateCloseButton = document.querySelector('a[title="Sluiten"]')
    this.languagesPanel = DropdownMenu(this.languageSwitchMenu)

    if (!this.languageSwitchMenu || !this.languagesPanel) {
      return
    }

    this.initListeners()
  }

  initListeners () {
    this.element.addEventListener('click', (event) => {
      event.preventDefault()
      const isOpen = this.languagesPanel.isOpen()
      this.element.classList.toggle('active', !isOpen)
      isOpen ? this.languagesPanel.close() : this.languagesPanel.open()
    })

    document.addEventListener('click', (event) => {
      clickedOutsideSingle(event, this.element) && this.languagesPanel.close()
    })

    // Checks if the browser remembered a translation from previous session and adjusts the menu
    document.addEventListener('gt-init', () => {
      setTimeout(() => {
        const lang = this.html.lang
        if (lang !== 'nl') {
          // Find the menu item for the current lang
          const menuItem = this.languageSwitchMenu.querySelector(`[data-lang="${lang}"]`)
          const name = menuItem ? menuItem.dataset.name : lang
          this.selectedLanguage.innerHTML = name

          for (const menuItem of this.languageSwitchMenu.children) {
            menuItem.classList.toggle('hidden', menuItem.dataset.lang === lang)
          }
        }
      }, 500)
    })

    const clickHandler = event => {
      event.preventDefault()
      const el = event.target.closest('.language-switch__menu-item')
      // Check if the clicked element is a valid menu item before proceeding
      if (!el) return
      this.changeLang(el.dataset.lang, el.dataset.name)
    }

    for (const lang of Array.from(this.languageSwitchMenu.querySelectorAll('.language-switch__menu-item'))) {
      lang.addEventListener('click', clickHandler)
    }
  }

  changeLang (lang, name) {
    if (!this.googleTranslateElement) return

    const select = this.googleTranslateElement.querySelector('.goog-te-combo')
    // Check if the Google Translate select element exists before proceeding
    if (!select) {
      console.warn('Google Translate select element not found')
      return
    }

    this.html.setAttribute('lang', lang)

    select.value = lang
    select.dispatchEvent(new Event('change'))

    // this.containerContent.style.marginTop = '-40px'
    this.selectedLanguage.innerHTML = name

    for (const menuItem of this.languageSwitchMenu.children) {
      menuItem.classList.toggle('hidden', menuItem.dataset.lang === lang)
    }

    // Hook on close-button of the Google Translate Widget iFrame
    this.reinitGteCloseListener()

    // Fix for weird bug where selecting dutch once would not trigger a fully working translation
    if (lang === 'nl' || lang === 'en') {
      setTimeout(() => {
        select.value = lang
        select.dispatchEvent(new Event('change'))
      }, 25)
    }
  }

  reinitGteCloseListener () {
    // Wait for the Google Translate iframe to load and attach close listener
    setTimeout(() => {
      const closeButton = document.querySelector('a[title="Sluiten"]')
      if (closeButton && !closeButton.dataset.listenerAttached) {
        closeButton.addEventListener('click', () => {
          this.element.classList.remove('active')
          this.languagesPanel.close()
        })
        closeButton.dataset.listenerAttached = 'true'
      }
    }, 100)
  }
}

window.addEventListener('init-load', () =>
  document.querySelectorAll('.language-switch').forEach((element) => {
    element.instance = element.instance || new LanguageSwitchComponent(element)
  })
)
